module.exports = __webpack_public_path__ + "static/media/xz06_grey.6123fa1c.png";